import React from "react";
import {
  Button,
  Modal,
} from "reactstrap";

export default function Dialog({
  open,
  title = "",
  message = "",
  button1Text = "Sim",
  button1OnPress,
  button2Text = "Não",
  button2OnPress,
  button3Text = "",
  button3OnPress,
}) {
  if (!open) { return null }
  return (
    <Modal isOpen={open} style={{ backgroundColor: 'white', borderRadius: '10px' }}>
      <div style={{
        padding: '10px',
        alignItems: 'center',
        backgroundColor: 'white',
        borderRadius: '10px'
      }}>
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', justifyContent: 'center', alignItems: 'center' }}>
          {title && (
            <div style={{ fontSize: 15, fontWeight: 'bold' }}>
              <p>{title}</p>
            </div>
          )}
          {message && (
            <div>
              <p>{message}</p>
            </div>
          )}
          <div style={{ display: 'flex', flexDirection: 'row-reverse', justifyContent: 'center' }}>
            {button1OnPress && (
              <div style={{ padding: 5 }}>
                <Button
                  color="primary"
                  onClick={() => button1OnPress()}
                >
                  {button1Text}
                </Button>
              </div>
            )}
            {button2OnPress && (
              <div style={{ padding: 5 }}>
                <Button
                  color="danger"
                  onClick={() => button2OnPress()}
                >
                  {button2Text}
                </Button>
              </div>
            )}
            {button3OnPress && (
              <div style={{ padding: 5 }}>
                <Button
                  color="warning"
                  onClick={() => button3OnPress()}
                >
                  {button3Text}
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </Modal>
  )
}
